import { call, put, select, takeEvery } from 'redux-saga/effects';
import { SET_PROTOCOL_DEVIATION_REPORT, SAVE_PROTOCOL_DEVIATION, UP_DATA_INITIAL, GET_PROTOCOL_DEVIATION, SUBMIT_PROTOCOL_DEVIATION } from 'store/key';
import { produce } from 'utility/general';
import { setGlobalLoading } from 'store/global/reducer';
import API from 'api/call';
import { safeSaga } from 'store';
import store from 'store';
import { setGlobal } from 'store/global/reducer';
import { statusLookup } from 'utility/lookup';

const initialState = {
    reportData: null,
    remoteDetail: {
        actualStudyStartDate: null,
        isNotYetStarted: false,
        addSupplements: [],
        deleteSupplements: [],
        studySite:null,
        signedFileName: '',
        signedFileId: '',
        protocolDeviationReportDetails:[{}],
    },
    rows: [],
    remoteDocIds: [],
    isLoading: false,
    forceErrorDisplay: false,
    oldData: {
        actualStudyStartDate: null,
        isNotYetStarted: false,
        studySite:null,
        protocolDeviationReportDetails:[{}],
    },
};
function* upDataInitial(action) {
    const { key, value } = action.payload;
    const { protocolDeviationReport } = yield select();
    protocolDeviationReport[key] = value;
    yield put({
        type: SET_PROTOCOL_DEVIATION_REPORT,
        payload: protocolDeviationReport,
    });
}

function* getProtocolDeviation(action) {
    const { docType, reportId, appId, isFormCreate, siteId } = action.payload;
    const { protocolDeviationReport } = yield select();
    protocolDeviationReport.isLoading = true;
    protocolDeviationReport.forceErrorDisplay = false;

    yield put({
        type: SET_PROTOCOL_DEVIATION_REPORT,
        payload: protocolDeviationReport,
    });

    try {
        let data = { docType: docType };
        if (isFormCreate) {
            data.appId = appId;
            data.reportId = null;
            if (siteId) {
                data.siteId = parseInt(siteId);
            }
        } else {
            data.reportId = reportId;
        }

        const res = yield call(API.postApprovalActivities.getReportDetail, data);
        const detail = res.data.result;
        protocolDeviationReport.remoteDetail = detail;
        protocolDeviationReport.remoteDetail.addSupplements = [];
        protocolDeviationReport.remoteDetail.deleteSupplements = [];
        protocolDeviationReport.rows = detail.supplementDocuments ?? [];
        protocolDeviationReport.remoteDocIds = detail.supplementDocuments?.map((item) => item.id);

        protocolDeviationReport.oldData.actualStudyStartDate = detail.actualStudyStartDate;
        protocolDeviationReport.oldData.isNotYetStarted = detail.isNotYetStarted;
        protocolDeviationReport.oldData.studySite = detail.studySite;
        protocolDeviationReport.oldData.protocolDeviationReportDetails = detail.protocolDeviationReportDetails;

        if (!isFormCreate) {
            let subNo = null,
                statusDisplay = null;
            if (detail.subNo) {
                subNo = detail.subNo;
            }
            if (detail.lastStatus !== null) {
                statusDisplay =
                    statusLookup.find((item) => {
                        return detail.lastStatus === item.key;
                    })?.statusDisplay || null;
            }
            store.dispatch(
                setGlobal({
                    postApprovalReportData: {
                        [reportId]: {
                            showNavigationSubNo: subNo,
                            showNavigationStatus: statusDisplay,
                        },
                    },
                }),
            );
        }
    } catch (error) {
        console.log('get protocolDeviation report detail failed:', error);
    }

    protocolDeviationReport.isLoading = false;
    yield put({
        type: SET_PROTOCOL_DEVIATION_REPORT,
        payload: protocolDeviationReport,
    });
}

function* saveProtocolDeviation(action) {
    const { callback, reportId, appId, isFormCreate, signedFileId,siteId } = action.payload;
    const { protocolDeviationReport } = yield select();

    setGlobalLoading(true);
    try {
        const {
            actualStudyStartDate,
            isNotYetStarted,
            addSupplements,
            deleteSupplements,
            studySite,
            piSiteName,
            protocolDeviationReportDetails,
        } = protocolDeviationReport.remoteDetail;

        let data = {
            actualStudyStartDate: actualStudyStartDate ? new Date(actualStudyStartDate) : null,
            isNotYetStarted,
            addSupplements,
            deleteSupplements,
            studySite,
            piSiteName,
            protocolDeviationReportDetails,
            appId: appId ?? protocolDeviationReport.remoteDetail.appId,
            signedFileId,
            siteId,
        };

        if (!isFormCreate) {
            data.reportId = reportId;
        }

        if(isNotYetStarted === null){
            data.isNotYetStarted = false;
        }

        if (siteId) {
            data.siteId = parseInt(siteId);
        }

        console.log('save reducer',data);

        const res = yield call(API.protocolDeviationReport.saveProtocolDeviation, data);

        const newReportId = res.data.result.reportId;
        callback?.(newReportId);
    } catch (error) {
        console.log('create/save protocolDeviation failed:', error);
    }
    setGlobalLoading(false);
}

function* submitProtocolDeviation(action) {
    const { callback, reportId, appId, isFormCreate, signedFileId,siteId } = action.payload;
    const { protocolDeviationReport } = yield select();

    setGlobalLoading(true);
    try {
        const {
            actualStudyStartDate,
            isNotYetStarted,
            addSupplements,
            deleteSupplements,
            studySite,
            piSiteName,
            protocolDeviationReportDetails,
        } = protocolDeviationReport.remoteDetail;

        let data = {
            actualStudyStartDate: actualStudyStartDate ? new Date(actualStudyStartDate) : null,
            isNotYetStarted,
            addSupplements,
            deleteSupplements,
            studySite,
            piSiteName,
            protocolDeviationReportDetails,
            appId: appId ?? protocolDeviationReport.remoteDetail.appId,
            siteId,
            signedFileId,
        };

        if (!isFormCreate) {
            data.reportId = reportId;
        }

        if (siteId) {
            data.siteId = parseInt(siteId);
        }

        console.log('submit reducer',data);

        try {
            const response = yield call(API.protocolDeviationReport.submitProtocolDeviation, data);
            if (response.status === 400) {
                throw new Error('Bad Request: The server returned a 400 status.');
            }
            callback?.();
        } catch (error) {
            console.log('submit protocolDeviation failed:', error);
            throw error; // Re-throw the error if needed
        }

        callback?.();
    } catch (error) {
        console.log('submit protocolDeviation failed:', error);
    }
    setGlobalLoading(false);
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_PROTOCOL_DEVIATION_REPORT:
            const newState = produce(state, (draft) => {
                Object.entries(action.payload).forEach(([key, value]) => {
                    draft[key] = action.payload[key];
                });
            });
            return newState;
        default:
            return state;
    }
};
export function* watchProtocolDeviationReport() {
    yield takeEvery(UP_DATA_INITIAL, safeSaga(upDataInitial));
    yield takeEvery(GET_PROTOCOL_DEVIATION, safeSaga(getProtocolDeviation));
    yield takeEvery(SAVE_PROTOCOL_DEVIATION, safeSaga(saveProtocolDeviation));
    yield takeEvery(SUBMIT_PROTOCOL_DEVIATION, safeSaga(submitProtocolDeviation));
}

export default reducer;
